import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Explanation_text from './Explanation_text';
import {Card} from './';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import StarIcon from '@material-ui/icons/Star';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
  root: {
    position:'relative',
    height:'100%',
    width: '100%',
    overflowY:'scroll',
    backgroundColor:(props)=>(props.background_colour==undefined)?undefined:props.background_colour,
  },
}));


export default function InsetList(props) {
  const classes = useStyles(props);

  return (
    <List component="nav" className={classes.root} aria-label="contacts">
    {(props.list_data['all']!=undefined)?
    <ListItem button onClick={(e)=>{if(props.block_click==true){e.stopPropagation(); e.preventDefault();}; props.onClick(props.list_data['all'])}} style={{borderBottomStyle:'solid', borderBottomColor:'#E8E8E8', borderBottomWidth:(props.no_border==true)?'0px':'1px'}}>
      {(props.list_data['all'].icon==undefined)?null:<ListItemIcon>{props.list_data['all'].icon}</ListItemIcon>}
      {(props.checkboxes==undefined || props.list_data['all'].no_checkbox==true)?null:<ListItemIcon><Checkbox checked={props.checkboxes.indexOf(props.list_data['all'].id) !== -1} onClick={(e)=>{e.stopPropagation(); e.preventDefault(); let new_checkboxes=[]; let done=false; for(let x of props.checkboxes){if(x==props.list_data['all'].id){done=true;}else{new_checkboxes.push(x);}} if(done==false){new_checkboxes.push(props.list_data['all'].id);} props.onChange(new_checkboxes);}}/></ListItemIcon>}
      <ListItemText primary={props.list_data['all'].main_text} secondary={props.list_data['all'].secondary_text}/>
    </ListItem>:null}
    {
      Object.keys(props.list_data).map(function(key, index){
        if(key=='all' || isNaN(key)==false){return(null);}
        console.log(key);
        let d=props.list_data[key];
        return(
          <ListItemComponent {...props} d={d} key={key}/>
        )
      })
    }{
      Object.keys(props.list_data).map(function(key, index){
        if(key=='all' || isNaN(key)==true){return(null);}
        console.log(key);
        let d=props.list_data[key];
        return(
          <ListItemComponent {...props} d={d} index={index} key={key}/>
        )
      })
    }
    </List>
  );
}


function ListItemComponent(props){
  const[isDragging, setIsDragging]=useState();
  const classes = useStyles(props);
  let index=props.index;
  let d=props.d;
  if(d==undefined){return null;}
  return(
    <DraggableCard handleDragChange={setIsDragging} draggable={props.draggable} movedItem={props.movedItem} onDrop={(item, folder_id)=>{props.onDrop(props.list_data[item.id], folder_id)}} is_folder={d.is_folder} id={d.id} index={index} content={<ListItem disableRipple={props.draggable} button onClick={(e)=>{if(props.block_click==true){e.stopPropagation(); e.preventDefault();}; props.onClick(d)}} style={{borderBottomStyle:'solid', borderBottomColor:'#E8E8E8', borderBottomWidth:(props.no_border==true)?'0px':'1px'}}>
      {(d.icon==undefined)?null:<ListItemIcon>{d.icon}</ListItemIcon>}
      {(props.checkboxes==undefined || d.no_checkbox==true)?null:<ListItemIcon><Checkbox color='primary' disabled={props.disable_checkbox} checked={props.checkboxes.indexOf(d.id) !== -1} onClick={(e)=>{e.stopPropagation(); e.preventDefault(); let new_checkboxes=[]; let done=false; for(let x of props.checkboxes){if(x==d.id){done=true;}else{new_checkboxes.push(x);}} if(done==false){new_checkboxes.push(d.id);} props.onChange(new_checkboxes);}}/></ListItemIcon>}
      {(props.secondary_checkboxes==undefined || d.no_checkbox==true)?null:<ListItemIcon style={{marginLeft:'-23px'}}><Checkbox color='secondary' disabled={props.disable_secondary_checkbox} checked={props.secondary_checkboxes.indexOf(d.id) !== -1} onClick={(e)=>{e.stopPropagation(); e.preventDefault(); let new_checkboxes=[]; let done=false; for(let x of props.secondary_checkboxes){if(x==d.id){done=true;}else{new_checkboxes.push(x);}} if(done==false){new_checkboxes.push(d.id);} props.onChangeSecondary(new_checkboxes);}}/></ListItemIcon>}
      <ListItemText primary={(d.main_text==undefined)?undefined:<Explanation_text inline text={d.main_text}/>} secondary={d.secondary_text}/>
      {(props.edit_on==true && d.edit==true)?<EditIcon color='primary' onClick={(e)=>{e.stopPropagation(); e.preventDefault(); props.onEdit(d);}}/>:null}
      {(props.delete_on==true && d.delete==true)?<DeleteIcon color='primary' onClick={(e)=>{e.stopPropagation(); e.preventDefault(); props.onDelete(d);}}/>:null}
    </ListItem>}/>
  )
}




function DraggableCard(props){
  console.log(props, 'PROPS!!!');
  if(props.draggable==true){
    return(
      <Card
      is_folder={props.is_folder}
      handleDragChange={props.handleDragChange}
      not_draggable={(props.id=='back')?true:false}
      onDrop={props.onDrop}
      key={props.id}
      index={props.index}
      id={props.id}
      moveCard={props.movedItem}
      text={props.content}/>
    )
  }else{
    return <div>{props.content}</div>;
  }
}
